import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Text,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Button,
} from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import type { NatRuleColumn } from '@duke-hq/avetmiss/NATTypes';

type NATFileRulesModalProps = {
  isOpen: boolean;
  onClose: () => void;
  columns: Record<string, NatRuleColumn>;
  description: string | null;
};

export function NATFileRulesModal({
  isOpen,
  onClose,
  columns,
  description = null,
}: NATFileRulesModalProps) {
  const headers = ['Column Name', 'Position', 'Size', 'Required'];
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Trans>NAT File Rules</Trans>
        </ModalHeader>
        <ModalBody maxH="40vh" overflowY="auto">
          {description != null ? (
            <Flex align="stretch" p={2} bg="gray.50" borderRadius="md" mb={4}>
              <Text fontSize="sm" color="gray.600">
                {description}
              </Text>
            </Flex>
          ) : null}
          <Table variant="simple" borderWidth="1px" borderColor="gray.200">
            <Thead>
              <Tr>
                {headers.map((header) => (
                  <Th key={header} border="1px solid" borderColor="gray.400" fontWeight="bold">
                    {header}
                  </Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {Object.entries(columns).map(([key, column]) => (
                <Tr key={key}>
                  <Td borderWidth="1px" borderColor="gray.200" fontWeight="medium">
                    {column.name}
                  </Td>
                  <Td borderWidth="1px" borderColor="gray.200">
                    {column.position}
                  </Td>
                  <Td borderWidth="1px" borderColor="gray.200">
                    {column.size}
                  </Td>
                  <Td borderWidth="1px" borderColor="gray.200">
                    {column.required ? 'Yes' : 'No'}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>
            <Trans>Close</Trans>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
